// Centralised plan feature gating for RoofMate.
// Pull `subscription_plan` from /auth/me. Defaults to "basic" if unknown so
// we never accidentally show paid features to a free user.

const PLAN_RANK = { basic: 0, pro: 1, enterprise: 2 };

export function getPlan(user) {
  const p = (user?.subscription_plan || 'basic').toLowerCase();
  return PLAN_RANK[p] !== undefined ? p : 'basic';
}

function hasMinPlan(user, minPlan) {
  return PLAN_RANK[getPlan(user)] >= (PLAN_RANK[minPlan] ?? 0);
}

// Capability flags — single source of truth for the UI.
// Admin role (platform admin) bypasses plan gates entirely.
export function getCapabilities(user) {
  const isAdmin = user?.role === 'admin';
  const isPro = isAdmin || hasMinPlan(user, 'pro');
  const isEnterprise = isAdmin || hasMinPlan(user, 'enterprise');
  return {
    // Pro+ measurement tools
    perimeter: isPro,
    multiDistance: isPro,
    heightEstimation: isPro,
    angleMeasurement: isPro,
    // Historical satellite imagery date selector — Pro & Enterprise. Per
    // product, free/basic tenants get only "Live" satellite imagery; paid
    // tenants unlock the full Esri Wayback archive (2014→present, ~194
    // snapshots) and can save a chosen date per project.
    imageryDate: isPro,
    // Enterprise-only advanced tools
    siteLogistics: isEnterprise,
    boundaries: isEnterprise,
    timeTravel: isEnterprise,
    // Convenience
    planLabel: isAdmin ? 'Admin' : getPlan(user).replace(/^./, c => c.toUpperCase()),
    isPro, isEnterprise, isAdmin,
  };
}
